<template>
  <div class="container px-4 xl:px-0">
    <div class="rounded-xl shadow-card font-lato lg:p-0 p-5 relative">
      <div class="block lg:hidden mb-3">
        <div class="flex flex-row space-x-4 justify-between">
          <div>
            <template v-if="product.isNew || product.count === 0">
              <div
                :class="[
                  mode === 'tile'
                    ? 'flex mb-4 relative sm:absolute sm:mb-0 sm:top-4 sm:left-4'
                    : '',
                  product.count === 0 ? 'bg-red' : 'bg-green',
                ]"
                class="flex justify-center whitespace-nowrap items-center text-white px-3 max-w-min h-7 rounded font-lato text-base"
              >
                {{ product.count === 0 ? "нет в наличии" : "новинка" }}
              </div>
            </template>
            <template v-else-if="product.count > 0">
              <div
                :class="
                  mode === 'tile'
                    ? 'flex mb-4 relative sm:absolute sm:mb-0 sm:top-4 sm:left-4'
                    : ''
                "
                class="space-x-2 bg-white flex whitespace-nowrap justify-center items-center px-2.5 max-w-min h-7 rounded"
                style="box-shadow: 0px 4px 20px 0px #48507029"
              >
                <p class="font-medium text-black font-lato text-base">
                  в наличии
                </p>
                <p-icon-check></p-icon-check>
              </div>
            </template>
          </div>
          <div class="flex justify-between">
            <div class="flex flex-row gap-4 font-lato bg-white">
              <div @click="addToFavorites()" class="cursor-pointer">
                <p-icon-favorite-black :isActive="isFavorite" />
              </div>
              <div class="w-[1px] bg-primary-25 hidden lg:block rounded"></div>
              <div class="block">
                <p-icon-share @click="togglePopup()"></p-icon-share>
                <p-share-mobile
                  v-if="width < 1024 && isPopupOpen"
                  @close-popup="isPopupOpen = false"
                ></p-share-mobile>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid lg:flex lg:flex-row lg:gap-0 lg:place-content-start place-content-center"
      >
        <div class="flex items-center">
          <p-card-detailed-slider :sliders="gallery" />
        </div>
        <div class="overflow-hidden hidden lg:block pl-3 py-7 pr-7 w-full">
          <div class="">
            <div class="flex justify-between space-x-4">
              <div class="font-lato text-base text-gray-900 relative">
                <div class="line-clamp-3" v-html="product.description"></div>

                <button
                  class="text-base pt-2 pb-3 text-secondary-300 font-normal font-sans"
                  v-if="product.description"
                  @click="emit('showMore')"
                >
                  Подробнее
                </button>
              </div>
              <div class="place-content-end">
                <p-wrapper class="flex flex-row gap-4 p-4">
                  <div @click="addToFavorites()" class="cursor-pointer">
                    <p-icon-favorite-black :isActive="isFavorite" />
                  </div>
                  <div class="w-[1px] bg-primary-25 rounded"></div>
                  <div class="cursor-pointer">
                    <p-icon-share @click="togglePopup()"></p-icon-share>
                    <p-share
                      v-if="isPopupOpen && width > 1024"
                      @close-popup="isPopupOpen = false"
                    ></p-share>

                    <!-- <div v-if="showCopiedText" class="absolute -top-5 left-1/5 transform -translate-x-2/4 text-black bg-secondary-25 py-1 px-3 rounded shadow">
      Скопировано
    </div> -->
                  </div>
                </p-wrapper>
              </div>
            </div>
            <div class="flex flex-row items-center gap-4">
              <div class="font-lato text-base text-gray-900">32 оценки</div>
              <div class="">
                <p-grade />
              </div>
            </div>
          </div>
          <div class="hidden lg:block">
            <p class="text-4xl font-bold pt-3">
              {{ formatMoneyWithCurrency(product.price) }}
            </p>
            <div class="flex gap-11 mt-5 items-center" v-if="isMounted">
              <template v-if="!isInCart">
                <p-button
                  height="medium"
                  type="secondary"
                  class="w-41"
                  :disabled="product.count === 0"
                  @click="addProductToCart"
                  >Купить</p-button
                >
              </template>
              <template v-else>
                <p-button
                  to="/cart"
                  height="medium"
                  type="secondary-light"
                  class="w-41 text-lg"
                  >В корзине</p-button
                >
                <p-cart-item-product-editor
                  v-if="product.count > 0"
                  :min="1"
                  :max="product.count"
                  :product="product"
                ></p-cart-item-product-editor>
              </template>
            </div>
          </div>
          <div class="lg:hidden block">
            <div
              class="fixed left-0 bottom-16 w-full place-content-center z-20"
            >
              <div class="container px-4 xl:px-0">
                <div class="rounded-xl p-3 bg-white shadow-card">
                  <div class="flex justify-between items-center">
                    <p class="text-3xl font-bold">
                      {{ formatMoneyWithCurrency(product.price) }}
                    </p>
                    <template v-if="!isInCart">
                      <p-button
                        height="medium"
                        type="secondary"
                        :disabled="product.count === 0"
                        @click="addProductToCart"
                        >Купить</p-button
                      >
                    </template>
                    <template v-else>
                      <p-button
                        height="medium"
                        type="secondary-light"
                        class="text-lg"
                        >В корзине</p-button
                      >
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden lg:block">
            <div
              class="flex flex-row font-sans gap-4 mt-8 text-base lg:text-sm"
            >
              <p-wrapper
                class="p-4 text-base flex items-center flex-row space-x-3"
                v-if="product.count > 0"
              >
                <span>В наличии </span>
                <p-icon-check class="w-5 h-5"></p-icon-check>
              </p-wrapper>

              <p-wrapper class="p-4">
                <div class="text-base">
                  Гарантия <span class="pl-2 text-gray-700">12 мес.</span>
                </div>
              </p-wrapper>
              <p-wrapper class="p-4">
                <span class="text-base">Доставка по Абхазии</span>
              </p-wrapper>
            </div>
          </div>
          <div
            class="hidden lg:block"
            v-if="productsByCategory && productsByCategory.length"
          >
            <div class="flex flex-col gap-4 mt-8">
              <div class="font-lato text-xl font-semibold">Аналоги</div>
              <div class="flex flex-row gap-4">
                <div v-for="item in productsByCategory">
                  <p-wrapper>
                    <div class="flex flex-row gap-4 p-3 max-w-80">
                      <div class="w-20 h-20">
                        <nuxt-link :to="`/product/${item.public_id}`">
                          <img
                            :src="item.imageUrl ? item.imageUrl : IMAGE_DEFAULT"
                            class="w-20 h-20 rounded-lg object-contain"
                            style="flex-shrink: 0"
                          />
                        </nuxt-link>
                      </div>
                      <div class="flex flex-col h-20 justify-between gap-2">
                        <nuxt-link :to="`/product/${item.public_id}`">
                          <p
                            class="text-sm line-clamp-2 !leading-5 text-gray-800"
                          >
                            {{ item.name }}
                          </p>
                        </nuxt-link>
                        <div
                          class="flex flex-row gap-5 justify-between items-center"
                        >
                          <div class="text-secondary-400 text-lg">
                            {{ formatMoneyWithCurrency(item.price) }}
                          </div>
                          <div class="h-8 hidden xl:block">
                            <nuxt-link :to="`/product/${item.public_id}`">
                              <p-button
                                class="px-2 h-8"
                                padding="absence"
                                height="small"
                                >Смотреть</p-button
                              >
                            </nuxt-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-wrapper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block pt-2 lg:pt-0 lg:hidden">
        <div class="flex justify-between items-center">
          <p class="text-gray-400 font-lato">Арт.{{ product.code }}</p>
          <div class="flex items-center gap-2">
            <div class="font-lato text-base text-gray-900 xs:block hidden">
              32 оценки
            </div>
            <p-grade></p-grade>
          </div>
        </div>
      </div>
      <div class="lg:hidden block relative">
        <div class="fixed left-0 bottom-0 w-full h-34 z-10">
          <div class="container lg:px-0 px-4">
            <div class="py-15 rounded-xl bg-white"></div>
          </div>
        </div>
        <div class="fixed left-0 bottom-16 w-full z-20">
          <div class="container px-4 xl:px-0">
            <div class="rounded-xl px-3 py-4 bg-white shadow-card">
              <div class="flex justify-between items-center">
                <p class="text-3xl font-bold">
                  {{ formatMoneyWithCurrency(product.price) }}
                </p>
                <template v-if="!isInCart">
                  <p-button
                    class="w-41"
                    height="medium"
                    type="secondary"
                    :disabled="product.count === 0"
                    @click="addProductToCart"
                    >Купить</p-button
                  >
                </template>
                <template v-else>
                  <p-button
                    to="/cart"
                    height="medium"
                    type="secondary-light"
                    class="text-lg w-41"
                    >В корзине</p-button
                  >
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFavoritesStore } from "~/stores/use-favorite-store";
import { useWindowSize } from "@vueuse/core";
const { width } = useWindowSize();
const isMounted = ref(false);
const { formatMoneyWithCurrency } = useMoneyFormater();
onMounted(() => {
  isMounted.value = true;
});

const props = defineProps({
  product: {
    type: Object,
    default: {
      description:
        "Однорычажный смеситель для раковины. Предназначен для умывальника. Смеситель в сборе, круглая уплотнительная прокладка, скоба фиксирующая металлическая с резиновым уплотнителем, крепежный шток с гайкой – 2 шт",
    },
    price: "3 500 ₽",
  },
  productsByCategory: {
    type: Array,
  },
});

const emit = defineEmits(["showMore"]);

const { addProductToCart, isInCart } = useCart(props.product);

const gallery = computed(() => {
  let images = [];
  if (props.product.imageUrl) {
    images.push(props.product.imageUrl);
  }
  props.product.images.forEach((element) => {
    images.push(element);
  });
  return images;
});

const { favorites, removeFavoriteProduct, addFavoriteProduct } =
  useFavoritesStore();
const isFavorite = computed(() =>
  favorites.some((element) => props.product.public_id === element.productId)
);

function addToFavorites() {
  if (isFavorite.value) {
    removeFavoriteProduct(props.product.public_id);
  } else {
    addFavoriteProduct(props.product.public_id);
  }
}
// const showCopiedText = ref(false);
// const copyLink = () => {
//   const urlToCopy = window.location.href;
//   navigator.clipboard.writeText(urlToCopy).then(() => {
//     console.log('Ссылка скопирована в буфер обмена:', urlToCopy);
//     showCopiedText.value = true;

//     setTimeout(() => {
//       showCopiedText.value = false;
//     }, 3000);
//   }).catch((err) => {
//     console.error('Ошибка копирования ссылки:', err);
//   });
// };

const isPopupOpen = ref(false);
function togglePopup() {
  isPopupOpen.value = !isPopupOpen.value;
}
</script>
